import Link from 'next/link';

import { PageInfo } from 'utils/types';

export default function Pagination({
  currentPage,
  pageInfo,
}: {
  currentPage: number;
  pageInfo: PageInfo;
}) {
  const { hasNextPage, hasPreviousPage } = pageInfo;
  return (
    <div className="space-y-2 pt-6 pb-8 md:space-y-5 md:w-72">
      <nav className="flex justify-between">
        {!hasPreviousPage && (
          <button
            className="cursor-auto disabled:opacity-50"
            disabled={!hasPreviousPage}
          >
            {`<< Previous`}
          </button>
        )}
        {hasPreviousPage && (
          <Link
            href={
              currentPage - 1 === 0 ? `/blog` : `/blog/page/${currentPage - 1}`
            }
          >
            <button>{`<< Previous`}</button>
          </Link>
        )}
        <span>|</span>
        {!hasNextPage && (
          <button
            className="cursor-auto disabled:opacity-50"
            disabled={!hasNextPage}
          >
            {`Next >>`}
          </button>
        )}
        {hasNextPage && (
          <Link href={`/blog/page/${currentPage + 1}`}>
            <button>{`Next >>`}</button>
          </Link>
        )}
      </nav>
    </div>
  );
}
